// extracted by mini-css-extract-plugin
export default {"formInputGroup":"FormInputGroup_formInputGroup__cTky0"};